import script from "./SoundList.vue?vue&type=script&setup=true&lang=js"
export * from "./SoundList.vue?vue&type=script&setup=true&lang=js"

import "./SoundList.vue?vue&type=style&index=0&id=c0c728ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c728ca"]])

export default __exports__